import * as Sentry from '@sentry/react'
import React, { ErrorInfo, ReactNode } from 'react'

import { ErrorBoundaryContent } from 'components/error-boundary/ErrorBoundaryContent'

interface ErrorBoundaryProps {
  children?: ReactNode
  fallback?: ReactNode
  resetKey?: string
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(__: Error): ErrorBoundaryState {
    return { hasError: true }
  }

  override componentDidUpdate(prevProps: ErrorBoundaryProps): void {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false })
    }
  }

  override componentDidCatch(error: Error, _errorInfo: ErrorInfo): void {
    Sentry.captureException(error)
  }

  override render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback || <ErrorBoundaryContent />
    }

    return this.props.children
  }
}

export default ErrorBoundary
